module.exports = __webpack_public_path__ + "img/xp4_rubble.9ad291a2.jpg";